type MenuItem = {
  label: string;
  url: string;
  submenuItems?: MenuItem[];
};

export const MenuItems: MenuItem[] = [
	{label: "navigation.rent", url: "/vermietung"},
	{label: "navigation.sale", url: "/verkauf"},
	{label: "navigation.grills", url: "/grills-und-mehr"},
	{label: "navigation.experiences", url: "/#slideshow"},
	{label: "navigation.aboutUs", url: "/ueber-uns"},
	{label: "navigation.contact", url: "/ueber-uns#contact"}
];
